import {observable, action, runInAction} from 'mobx'
import homeAPI from '../apis/homeAPI'
import alertMessage from '../utils/alertMessage'
import moment from 'moment'

export default class HomeStore {
  constructor(rootStore) {
    this.rootStore = rootStore
  }

  @observable isFetchingBusiness = false
  @observable isFetchingAPI = false
  @observable isFetchingMessage = false
  @observable isFetchingDistribution = false

  /*get records*/
  @observable messageRecord = {
    apiCustomer: [],
    messageCustomer: [],
    messageShortName: [],
    messageDistructionCustomer: [],
    messageDistructionShortName: [],
  }

  @action
  async onGetCountAction() {
    try {
      this.messageRecord = {
        apiCustomer: [],
        messageCustomer: [],
        messageShortName: [],
        messageDistructionCustomer: [],
        messageDistructionShortName: [],
      }
      const response = await homeAPI.getCountAction()
      runInAction(() => {
        if (response.data.code === 0 && response.data.data !== null) {
          /*shortName*/
          this.messageRecord = {
            apiCustomer: response.data.data.apiCustomer !== null ? JSON.parse(response.data.data.apiCustomer) : [],
            messageCustomer: response.data.data.messageCustomer !== null ? JSON.parse(response.data.data.messageCustomer) : [],
            messageShortName: response.data.data.messageShortName !== null ? JSON.parse(response.data.data.messageShortName) : [],
            messageDistructionCustomer: response.data.data.messageDistructionCustomer !== null ? JSON.parse(response.data.data.messageDistructionCustomer) : [],
            messageDistructionShortName: response?.data.data.messageDistructionShortName !== null ? JSON.parse(response?.data.data.messageDistructionShortName) : [],
          }
        }
      })
      return response
    } catch (err) {
      runInAction(() => {
      })
    }
  }

  /*save records*/
  @action
  async onSaveCountAction(value) {
    try {
      const response = await homeAPI.saveCountAction(value)
      runInAction(() => {
        if (response.data.code === 200) {
          // alertMessage.success('change Success！')
        } else {
          // alertMessage.error('change Failed！' + response.data.data +'')
        }
      })
    } catch (err) {
      alertMessage.error(err.message)
      runInAction(() => {
      })
    }
  }

  /*customer list start*/
  @observable customerList = []
  @observable apiCustomer = []
  @observable messageCustomer = []
  @observable messageDistructionCustomer = []

  @action
  async onGetCustomerAction(searchItem, value) {
    try {
      this.customerList = []
      this.apiCustomer = []
      this.messageCustomer = []
      this.messageDistructionCustomer = []
      const response = await homeAPI.getIngestionAction(searchItem)
      runInAction(() => {
        if (response.data.code === 0 && response.data.data !== null) {
          this.customerList = response.data.data
          if (value === '1') {
            /*customer and shortName. delete invalid data*/
            var customerListArr = []
            if (response.data.data.length > 0) {
              response.data.data.map(item => customerListArr.push(item.id))
            }
            if (this.messageRecord.apiCustomer.length > 0) {
              for (let i = 0; i < customerListArr.length; i++) {
                this.messageRecord.apiCustomer.filter(item => item === customerListArr[i]).map(it => this.apiCustomer.push(it))
              }
            }
            if (this.messageRecord.messageCustomer.length > 0) {
              for (let j = 0; j < customerListArr.length; j++) {
                this.messageRecord.messageCustomer.filter(item => item === customerListArr[j]).map(it => this.messageCustomer.push(it))
              }
            }
            // get API Statistics data
            if (this.apiCustomer.length > 0) {
              this.onSearchApiStateAction({customers: Array.from(this.messageCustomer)})
            }
            if (this.messageRecord.messageDistructionCustomer.length > 0) {
              for (let i = 0; i < customerListArr.length; i++) {
                this.messageRecord.messageDistructionCustomer.filter(item => item === customerListArr[i]).map(it => this.messageDistructionCustomer.push(it))
              }
            }
          }
        } else {
          alertMessage.error('Failed！ Data Platfrom no data!')
        }
      })
      return response
    } catch (err) {
      alertMessage.error(err.message)
      runInAction(() => {
      })
    }
  }

  /*customer list end*/
  @action
  onChangeCustomerList(value) {
    this.customerList = value
  }

  /*change shortName format*/
  @action
  onChangeMessageShortName(value) {
    this.messageShortName = value
  }

  @action
  clearMessageShortName() {
    this.messageShortName = []
  }

  @action
  onChangeMessageDistructionShortName(value) {
    this.messageDistructionShortName = value
  }

  @action
  onCompareMessageDistructionShortName(value, values) {
    var apiShortNamesArr = []
    var thisMessageRecord = value
    var newArr = []
    values.map(item => apiShortNamesArr.push(item.shortName))
    apiShortNamesArr = Array.from(apiShortNamesArr)
    if (thisMessageRecord.length > 0) {
      for (let i = 0; i < apiShortNamesArr.length; i++) {
        thisMessageRecord.filter(item => item === apiShortNamesArr[i]).map(it => newArr.push(it))
      }
    }
    return Array.from(newArr)
  }

  @action
  onChangeMessageCustomer(value) {
    this.messageCustomer = value
  }

  @action
  onChangeMessageDistructionCustomer(value) {
    this.messageDistructionCustomer = value
  }

  /*message Statistics shortName start*/
  @observable searchItemShortNames = {
    customers: []
  }
  @observable shortNames = []
  @observable messageShortName = []

  @action
  async onGetShortName(searchItem) {
    try {
      this.shortNames = []
      this.searchItemShortNames = searchItem
      const response = await homeAPI.getApiShortName(searchItem)
      runInAction(() => {
        if (response.data.code === 0 && response.data.data !== null) {
          this.shortNames = response.data.data
        } else {
          alertMessage.error('Failed！ Data Platfrom no data!')
        }
      })
      return response
    } catch (err) {
      alertMessage.error(err.message)
      runInAction(() => {
      })
    }
  }

  /*message Statistics shortName end*/

  /*Message Distribution shortName start*/
  @observable searchItemApiShortNames = {
    customers: []
  }
  @observable apiShortNames = []
  @observable messageDistructionShortName = []

  @action
  async onGetApiShortName(searchItem) {
    try {
      this.apiShortNames = []
      this.searchItemApiShortNames = searchItem
      const response = await homeAPI.getApiShortName(searchItem)
      runInAction(() => {
        if (response.data.code === 0 && response.data.data !== null) {
          this.apiShortNames = response.data.data
        } else {
          alertMessage.error('Failed！ Data Platfrom no data!')
        }
      })
      return response
    } catch (err) {
      alertMessage.error(err.message)
      runInAction(() => {
      })
    }
  }

  /*Message Distribution shortName end*/

  /*Business Statistics start*/
  @observable searchItemBusiness = {
    startTime: moment().format('YYYY-MM-DD') + ' 00:00:00',
    endTime: moment().format('YYYY-MM-DD') + ' 23:59:59',
  }
  @observable businessList = []

  @action
  async onGetBusinessAction(searchItem) {
    this.isFetchingBusiness = true
    try {
      this.businessList = []
      this.searchItemBusiness = searchItem
      const response = await homeAPI.getBusinessAction(searchItem)
      runInAction(() => {
        this.isFetchingBusiness = false
        if (response.data.code === 0) {
          if (response.data.data !== null) {
            const oldList = response.data.data
            oldList.map(item=>{
              return this.businessList.push({
                label: item?.name,
                type: 'Inbound',
                value: item?.inboundSum,
              },{
                label: item?.name,
                type: 'Outbound',
                value: item?.outboundSum,
              })
            })
          } else {
            alertMessage.error('Failed！ Data Platfrom no data!')
          }
        } else {
          alertMessage.error('Failed！' + response.data?.messageEn)
        }
      })
    } catch (err) {
      alertMessage.error(err.message)
      runInAction(() => {
        this.isFetchingBusiness = false
      })
    }
  }

  /*Business Statistics end*/


  /*api start*/
  @observable searchItemApi = []
  @observable apiList = []
  @observable apiSelectList = []

  @action
  async onSearchApiStateAction(searchItem) {
    this.isFetchingAPI = true
    try {
      this.apiList = []
      this.apiSelectList = []
      this.searchItemApi = searchItem
      const response = await homeAPI.searchApiAction(searchItem)
      runInAction(() => {
        this.isFetchingAPI = false
        if (response.data.code === 0 && response.data.data !== null) {
          this.apiList = response.data?.data || []
          if(response.data?.data.length>0) {
            response.data.data.map((item,index)=> {
              return this.apiSelectList.push({id: index, value: item?.customer, label: item?.customer})
            })
          }
        } else {
          alertMessage.error('Failed！ Data Platfrom no data!')
        }
      })
    } catch (err) {
      alertMessage.error(err.message)
      runInAction(() => {
        this.isFetchingAPI = false
      })
    }
  }

  /*api end*/

  /*message Statistics data start*/
  @observable searchItemMessage = {
    'startTime': moment().format('YYYY-MM-DD') + ' 00:00:00',
    'endTime': moment().format('YYYY-MM-DD') + ' 23:59:59',
    'messageDistributionCustomerVoList': [],
  }
  @observable messagesList = [] //column
  @action
  async onSearchMessageAction(searchItem) {
    this.isFetchingMessage = true
    try {
      this.messagesList = []
      this.searchItemMessage = searchItem
      const response = await homeAPI.searchMessageAction(searchItem)
      runInAction(() => {
        this.isFetchingMessage = false
        if (response.data.code === 0) {
          if (response.data.data === null) {
            alertMessage.error('Failed！ Data Platfrom no data!')
          } else {
            this.messagesList = response.data.data
          }
        } else {
          alertMessage.error('Message Statistics get data Failed！' + response.data?.messageEn)
        }
      })
      return response
    } catch (err) {
      alertMessage.error(err.message)
      runInAction(() => {
        this.isFetchingMessage = false
      })
    }
  }

  /*message Statistics data end*/

  /*Message Distribution data start*/
  @observable searchItemMessageDistribution = {
    'startTime': moment().format('YYYY-MM-DD') + ' 00:00:00',
    'endTime': moment().format('YYYY-MM-DD') + ' 23:59:59',
    'messageDistributionCustomerVoList': [],
  }
  @observable messagesDistributionList = [] //line
  @action
  async onSearchMessageDistributionAction(searchItem) {
    this.isFetchingDistribution = true
    try {
      this.messagesDistributionList = []
      this.searchItemMessageDistribution = searchItem
      const response = await homeAPI.searchMessageDistributionAction(searchItem)
      runInAction(() => {
        this.isFetchingDistribution = false
        if (response.data.code === 0) {
          if (response.data.data === null) {
            alertMessage.error('Failed！ Data Platfrom no data!')
          } else {
            this.messagesDistributionList = response.data.data
          }
        } else {
          alertMessage.error('Message Distribution get data Failed！' + response.data?.messageEn)
        }
      })
    } catch (err) {
      alertMessage.error(err.message)
      runInAction(() => {
        this.isFetchingDistribution = false
      })
    }
  }

  /*Message Distribution data end*/


  /*change customer params*/
  @action
  onChangeCustomer(newShortNames) {
    var testShortNames = []
    var submitShortNames = []
    for (var i = 0; i < newShortNames.length; i++) {
      if (testShortNames.indexOf(newShortNames[i].customer) === -1) {
        submitShortNames.push({
          customer: newShortNames[i].customer,
          shortName: [newShortNames[i].shortName]
        })
        testShortNames.push(newShortNames[i].customer)
      } else {
        for (var j = 0; j < submitShortNames.length; j++) {
          if (submitShortNames[j].customer === newShortNames[i].customer) {
            submitShortNames[j].shortName.push(newShortNames[i].shortName)
            break
          }
        }
      }
    }
    return submitShortNames
  }

  @action
  onChangeData() {
    this.businessList = []
    this.apiList = []
    this.messagesList = []
    this.messagesDistributionList = []
  }
}
